export enum ClaimAuditStatus {
  NotApplicable = 1,
  NotApproved = 2,
  InReview = 3,
  Approved = 4,
  Denied = 5
}